<div class="shift-details-container">
  <div class="panel-title">
    {{ assignment.routeName }}
  </div>
  <div class="panel-content">
    <div>
      {{ assignment.vehicleName }}
    </div>
    <div>
      {{ assignment.driverName }}
    </div>
    <div>
      {{ assignment.onAssignmentFrom | date:'MMM d h:mma' }} Start
    </div>
    <div>
      {{ assignment.completed | date:'MMM d h:mma' }} Finish
    </div>
    <div>
      {{ getDuration() | duration }} Total Duration
    </div>
    <div>
      {{ (assignment.percentCompleted * 100).toFixed(1) }}% Completed
    </div>
    @if (assignment.timeDrivenOffRoute) {
      <div>
        {{ assignment.timeDrivenOffRoute | duration }} Time off Route
      </div>
    }
    @if (assignment.timeDrivenOnRoute) {
      <div>
        {{ assignment.timeDrivenOnRoute | duration }} Time on Route
      </div>
    }
    <div>
      {{ (distances?.distance || 0) | distance:configuration.useMetricSystem:false }} Total {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }}
    </div>
    @if (assignment.distanceDrivenOffRoute) {
      <div>
        {{ assignment.distanceDrivenOffRoute / 1000 | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} off Route
      </div>
    }
    @if (assignment.distanceDrivenOnRoute) {
      <div>
        {{ assignment.distanceDrivenOnRoute / 1000 | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} on Route
      </div>
    }
    @if (assignment.routeLength) {
      <div>
        {{ (1 - assignment.percentCompleted) * assignment.routeLength / 1000 | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Remaining on Route
      </div>
    }
    @if (distances) {
      @if (configuration && shift.vehicleHardwareConfiguration &&
      shift.vehicleHardwareConfiguration.sensorInputs &&
      shift.vehicleHardwareConfiguration.sensorInputs.length > 0
        ) {
        @for (sensorType of HardwareConfiguration.getAggregatedSensorTypesForStatistics(shift.vehicleHardwareConfiguration.sensorInputs); track sensorType) {
          @if (sensorType === SensorType.PLOW) {
            <div>
              {{ distances.distancePlowed | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Plowed
            </div>
            <div>
              {{ distances.distance - distances.distancePlowed | distance:configuration.useMetricSystem:false }}
              ({{ ((distances.distance - distances.distancePlowed) / distances.distance * 100).toFixed(0) || 'N/A' }} %)
              Deadhead
              {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }}
            </div>
          } @else if (sensorType === SensorType.GRANULAR_SPREADER) {
            <div>
              {{ distances.distanceSpreadGranular | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Granular Spread
            </div>
            <!-- TODO no data yet
            <div>
              {{ shift.materialUsedGranular | weight:configuration.useMetricSystem }} Granular
            </div>-->
          } @else if (sensorType === SensorType.LIQUID_SPREADER) {
            <div>
              {{ distances.distanceSpreadLiquid | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Liquid Spread
            </div>
            <!-- TODO no data yet
            <div>
              {{ shift.materialUsedLiquid | volume:configuration.useMetricSystem }} Liquid
            </div>-->
          } @else if (sensorType === SensorType.MOWER) {
            <div>
              {{ distances.distanceMowed | distance:configuration.useMetricSystem }} Mowed
            </div>
          } @else if (sensorType === SensorType.SWEEPER) {
            <div>
              {{ distances.distanceSwept | distance:configuration.useMetricSystem }} Swept
            </div>
          }
        }
      }
    }
  </div>

  <div class="panel-title">
    Observations
  </div>
  <div class="panel-content">
    @if (observations && observations.length > 0 && observationItems) {
      @for (item of observationItems; track item) {
        <app-action-menu-item [input]="item"></app-action-menu-item>
      }
    } @else {
      <span>None</span>
    }
  </div>

</div>
